import _ from 'lodash';
import OfflineMonitor from '../webworkers/offlinemonitor.worker.js';

/**
 * Offline Monitor will start the webworker to monitor connectivity
 * This will trigger when the applicaiton loses connectivity
 * This middleware should execute only for START_OFFLINE_MONITOR middleware
 */
const offlineMonitor = (config) => (store) => (next) => (action) => {
	const START_OFFLINE_MONITOR = 'START_OFFLINE_MONITOR',
		UPDATE_APP_ONLINE_STATE = 'UPDATE_APP_ONLINE_STATE';

	if (action.type != START_OFFLINE_MONITOR) {
		return next(action);
		console.log(
			'AppOnlineState Middleware: any action other than GET_BOOKMARK_TASKS should continue to next middleware'
		);
	}

	//Check for config availability
	if (!config) {
		const configMsg = `
        Config unavailable.
        The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}

	if (!action.meta) {
		action.meta = {};
	}

	//TODO: calls during offline
	return next({
		type: UPDATE_APP_ONLINE_STATE,
		meta: {
			worker: OfflineMonitor,
			workerParams: {
				url: action.url
			},
			offlinemonitor: true
		}
	});
	//return next(action);
};

export default offlineMonitor;
